import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Nav from "./Components/navbar/Nav";
import BotNav from "./Components/bottomNavbar/BotNav"
import HomePage from "./Components/homePage/HomePage";
import Comm from "./Components/community/Comm";
import TopSection from "./Components/Our-services/Topsection/TopSection";
import ScrollToTop from "./ScrollToTop";
import OurProjects from "./Components/ourProjects/OurProjects";
import AboutUs from "./Components/aboutUs/AboutUs";
import SearchAkiya from "./Components/akiyaSearch/SearchAkiya";
import Prefec from "./Components/prefecture/Prefec";
import Intern from "./Components/Internship/TopSection/Intern";
import IndividProp from "./Components/individualProperty/IndividProp";
import IndiviualAkiya from "./Components/individualAkiya/IndividualAkiya";
import BlogWriting from "./Components/BlogWriting/BlogWriting";
import AllBlogs from "./Components/AllBlogs/AllBlogs";
import SingleBlog from "./Components/SingleBlog/SingleBlog";
import Terms from "./Components/Terms/Terms";
import ProfileMain from "./Components/profileSettings/ProfileMain";
import Protected from "./Components/Protected";
import ProfileSetting from "./Components/profileSettings/ProfileSetting";
import AkiyaConcierge from "./Components/akiyaConcierge/AkiyaConcierge";
import PageNotFound from "./Components/extraPages/PageNotFound";
import Kominka from "./Components/KominkaSmile/Kominka";
import IndiviualKominkaAkiya from "./Components/individualKominkaAkiya/IndividualKominkaAkiya";
import AkiyaOnNews from "./Components/AkiyaOnNews/AkiyaOnNews";
import AkiyaTweak from "./Components/AkiyaTweak/AkiyaTweak";
import AdminProtected from "./AdminProtected";
import Test from "./Components/Misc/Test";
import Acquisition from "./Components/Misc/Acquisition/Acquisition";
import Renovation from "./Components/Misc/Renovation/Renovation";
import SellerAndAssetManagement from "./Components/Misc/SellerAndAssetManagement/SellerAndAssetManagement";
import HowItWorks from "./Components/Our-services/HowItWorks/HowItWorks";
import WhatItCosts from "./Components/Our-services/WhatItCosts/WhatItCosts";
import InvestInAkiya from "./Components/InvestInAkiya/InvestInAkiya";
import DownloadProspectusFile from "./Components/Our-services/DownloadProspectus/DownloadProspectusFile";
import ReactGA4 from "react-ga4";
import MetaTagsUpdater from "./Components/MetaTagsUpdater";
import SpecialIndividProp from "./Components/SpecialindividualProperty/SpecialIndividProp";
import StructuredData from './StructuredData';
import ProfileSettingAvatar from "./Components/profileSettings/ProfileSettingAvatar";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MapWiseNotification from "./Components/MapWiseNotification/MapWiseNotification";
import IndividualNews from "./pages/IndividualNews/IndividualNews";
import NewsAdmin from "./pages/NewsAdmin/NewsAdmin";
import UnderConstruction from "./pages/UnderConstruction/UnderConstruction";
import SortingPreferences from "./pages/AlertServiceSetting/AlertServiceSetting";

// NEW IMPORTS - Agent System
import { AgentProvider } from "./Context/AgentContext";
import AgentDashboard from "./pages/RealEstateAdminPages/AgentDashboard";
import AddListingPage from "./pages/Extras/AddListingPage";
import MyListingsPage from "./pages/Extras/MyListingsPage";
import ProfileManagementPage from "./pages/Extras/ProfileManagementPage";
import PublicListingsPage from "./pages/Extras/PublicListingsPage";

import SuperAdminPanel from "./pages/waste/SuperAdminPanel";
import AgentProtected from "./Components/Agents/AgentProtected"; // New component we'll create

import AgentRegistration from "./pages/RealEstateAdminPages/AgentLogin";

import AgentPublicProfile from "./Components/Agents/AgentsPublicProfile";
import GoogleTranslateButton from "./Components/GoogleTranslateButton";
import AgentsDirectory from "./pages/AgentsDirectory/AgentsDirectory";
// import SelectiveLanguageToggle from "./Components/SelectiveLanguageToggle";


// import { WebVitals } from 'web-vitals-react-hook';

const TRACKING_ID = "G-9X7C3TVRWJ";

function App() {

  const location = useLocation();



  useEffect(() => {
    if (typeof window !== "undefined") {
      ReactGA4.initialize(TRACKING_ID);
      ReactGA4.send({
        hitType: "pageview",
        page: window.location.pathname + window.location.search,
      });
    }
  }, []);

  return (
    <AgentProvider>

      <div className="App overflow-x-hidden main-content">

        <ScrollToTop />
        <StructuredData />

        <GoogleTranslateButton pathname={location.pathname} />

        <div className="content">
          <header>
            <Nav />
          </header>
          <MetaTagsUpdater />
          <ToastContainer />

          <main>
            <Routes>
              {/* MAIN WEBSITE ROUTES */}
              <Route index element={<HomePage />} />
              <Route path="/our-services" element={<TopSection />} />

              <Route path="/agents-directory" element={<AgentsDirectory />} />


              <Route path="/our-projects" element={<OurProjects />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/internship" element={<Intern />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/property/:propertyId" element={<IndividProp />} />
              <Route path="/special-property/:propertyId" element={<SpecialIndividProp />} />
              <Route path="/community" element={<Comm />} />
              <Route path="/blogs" element={<AllBlogs />} />
              <Route path="/blogs/:blogId/:blogSlug" element={<SingleBlog />} />
              <Route path="/akiya-search" element={<SearchAkiya />} />
              <Route path="/akiya-concierge" element={<AkiyaConcierge />} />
              <Route path="/page-not-found" element={<PageNotFound />} />
              <Route path="/kominka" element={<Kominka />} />
              <Route path="/news" element={<AkiyaOnNews />} />
              <Route path="/services/how-it-works" element={<HowItWorks />} />
              <Route path="/services/what-it-costs" element={<WhatItCosts />} />
              <Route path="/invest-in-akiya" element={<InvestInAkiya />} />
              <Route path="/prefecture-listing/:prefecture_name" element={<Prefec />} />
              <Route path="/individual-akiya/:akiya_id" element={<IndiviualAkiya />} />
              <Route path="/individual_kominka/:akiya_id" element={<IndiviualKominkaAkiya />} />
              <Route path="/download-prospectus" element={<DownloadProspectusFile />} />
              <Route path="/news/:newsId/:newsSlug" element={<IndividualNews />} />
              <Route path="/under-construction" element={<UnderConstruction />} />

              {/* AGENT SYSTEM ROUTES - New Real Estate Platform */}

              

              <Route path="/agent/register" element={
               <AdminProtected password="superadmin2024">
               <AgentRegistration />
               </AdminProtected>
                } />
              <Route path="/agent/:agentId" element={<AgentPublicProfile />} />

              <Route path="/agent/dashboard" element={
                <Protected>
                <AgentProtected>
                  <AgentDashboard />
                </AgentProtected>
                </Protected>

              } />

              <Route path="/agent/add-listing" element={
                <AgentProtected>
                  <AddListingPage />
                </AgentProtected>
              } />
              <Route path="/agent/my-listings" element={
                <AgentProtected>
                  <MyListingsPage />
                </AgentProtected>
              } />
              <Route path="/agent/profile" element={
                <AgentProtected>
                  <ProfileManagementPage />
                </AgentProtected>
              } />
              
              {/* PUBLIC LISTINGS - Anyone can view */}
              <Route path="/listings" element={<PublicListingsPage />} />
              
              {/* SUPER ADMIN ROUTES */}
              <Route path="/super-admin" element={
                // <AdminProtected password="superadmin2024">
                  <SuperAdminPanel />
                // </AdminProtected>
              } />

              {/* USER PROTECTED PAGES - Existing */}
              <Route path="/blog-writing" element={
                <Protected>
                  <BlogWriting />
                </Protected>
              } />
              <Route path="/profile" element={
                <Protected>
                  <ProfileMain />
                </Protected>
              } />


              <Route path="/profile-settings" element={
                <Protected>
                  <ProfileSetting />
                </Protected>
              } />

              <Route path="/alert-service-settings" element={
                <Protected>
                  <SortingPreferences />
                </Protected>
              } />
              <Route path="/profile-avatar" element={
                <Protected>
                  <ProfileSettingAvatar />
                </Protected>
              } />
              <Route path="/listing-email-alert" element={
                <Protected>
                  <MapWiseNotification />
                </Protected>
              } />

              {/* ADMIN PAGES - Existing */}
              <Route path="/tweak/:id" element={
                <AdminProtected password="aezakmi">
                  <AkiyaTweak />
                </AdminProtected>
              } />
              <Route path="/miscTesting" element={
                <AdminProtected password="valdrion">
                  <Test />
                </AdminProtected>
              } />
              <Route path="/service/acquisition-service" element={
                <AdminProtected password="valdrion">
                  <Acquisition />
                </AdminProtected>
              } />
              <Route path="/service/renovation-service" element={
                <AdminProtected password="valdrion">
                  <Renovation />
                </AdminProtected>
              } />
              <Route path="/service/asset-service" element={
                <AdminProtected password="valdrion">
                  <SellerAndAssetManagement />
                </AdminProtected>
              } />
              <Route path="/newsAdmin" element={
                <AdminProtected password="newdata">
                  <NewsAdmin />
                </AdminProtected>
              } />

              {/* CATCH ALL */}
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </main>
        </div>
        
        <footer>
          <BotNav />
        </footer>
      </div>
    </AgentProvider>
  );
}

export default App;

